/*
 * Radial Bar chart with a single bar, showing progress from a value out of a defined total
 * The value & total are rendered inside the pie chart
 */
import React from 'react';
import { useTheme } from 'styled-components';
import { useIntl } from 'react-intl';

import messages from './messages';
import { RadialBarChart, RadialBar, PolarAngleAxis } from 'recharts';

const ProgressRadialBar = ({ size = 100, value, total, formatValue = (arg) => arg, renderValue = (arg) => arg }) => {
    const intl = useIntl();
    const theme = useTheme();
    return (
        <RadialBarChart
            width={size}
            height={size}
            cx={size / 2}
            cy={size / 2}
            outerRadius={size / 2 - 5}
            innerRadius={size / 2 - 5}
            barSize={3}
            data={[{ value }]}
            startAngle={90}
            endAngle={-270}
        >
            <PolarAngleAxis type="number" domain={[0, total]} angleAxisId={0} tick={false} />
            <RadialBar
                background
                clockWise
                dataKey="value"
                cornerRadius={size / 2}
                fill={theme.colour.primary}
                isAnimationActive={false}
            />
            <text x={size / 2} y={size / 2 - 7} textAnchor="middle" dominantBaseline="middle">
                {renderValue(formatValue(value))}
            </text>
            <text
                x={size / 2}
                y={size / 2 + 7}
                textAnchor="middle"
                dominantBaseline="middle"
                style={{ fontSize: '75%', color: 'gray' }}
            >
                {intl.formatMessage(messages.outOfTotalLabel, {
                    total: formatValue(total),
                })}
            </text>
        </RadialBarChart>
    );
};

export default ProgressRadialBar;
